<template>
    <div>
        <v-container
            fluid
            id="widget-application-form-frame"
            class="widget-application-form widget-component"
        >
            <v-container class="container-width">
                <v-form
                    ref="form"
                    v-model="formValid"
                    lazy-validation
                    :disabled="formDisabled"
                >
                    <v-row align="start">
                        <v-col cols="12" sm="6" md="7" lg="8">
                            <h1
                                class="mb-4"
                                :class="normalizedOptions.title.classes"
                                :style="normalizedOptions.title.style"
                                v-if="normalizedOptions.title.show"
                            >
                                {{ normalizedOptions.title.text }}
                            </h1>

                            <div
                                v-if="normalizedOptions.intro.show"
                                v-html="normalizedOptions.intro.textHtml"
                                :class="normalizedOptions.intro.classes"
                                :style="normalizedOptions.intro.style"
                            ></div>
                        </v-col>

                        <v-col
                            cols="12"
                            sm="6"
                            md="5"
                            lg="4"
                            v-if="normalizedOptions.listingCard.show"
                        >
                            <listing-card
                                v-if="listing"
                                :show-link-to-listing="true"
                                :link-to-listing="listingUrl"
                                :listing="listing"
                            >
                            </listing-card>
                        </v-col>

                        <v-col cols="12">
                            <v-stepper v-model="step" alt-labels flat>
                                <v-stepper-header>
                                    <v-stepper-step
                                        :complete="step > 1"
                                        step="1"
                                        :rules="[() => !tabErrors[1]]"
                                    >
                                        <span class="d-block text-center"
                                            >Details</span
                                        >
                                        <small v-if="tabErrors[1]"
                                            >Step missing required
                                            information!</small
                                        >
                                    </v-stepper-step>

                                    <v-divider></v-divider>

                                    <v-stepper-step
                                        :complete="step > 2"
                                        step="2"
                                        :rules="[() => !tabErrors[2]]"
                                    >
                                        <span class="d-block text-center"
                                            >Employment</span
                                        >
                                        <small v-if="tabErrors[2]"
                                            >Step missing required
                                            information!</small
                                        >
                                    </v-stepper-step>

                                    <v-divider></v-divider>

                                    <v-stepper-step
                                        :complete="step > 3"
                                        step="3"
                                        :rules="[() => !tabErrors[3]]"
                                    >
                                        <span class="d-block text-center"
                                            >Income</span
                                        >
                                        <small v-if="tabErrors[3]"
                                            >Step missing required
                                            information!</small
                                        >
                                    </v-stepper-step>

                                    <v-divider></v-divider>

                                    <v-stepper-step
                                        :complete="step > 4"
                                        step="4"
                                        :rules="[() => !tabErrors[4]]"
                                    >
                                        <span class="d-block text-center"
                                            >Living</span
                                        >
                                        <small v-if="tabErrors[4]"
                                            >Step missing required
                                            information!</small
                                        >
                                    </v-stepper-step>
                                </v-stepper-header>

                                <v-stepper-items>
                                    <v-stepper-content step="1">
                                        <v-row class="mt-2">
                                            <v-col cols="12">
                                                <v-select
                                                    v-model="
                                                        formFields.applicantsNumber
                                                    "
                                                    :items="applicantsChoices"
                                                    item-text="text"
                                                    item-value="value"
                                                    label="Number of Applicants"
                                                    outlined
                                                    required
                                                    hide-details="auto"
                                                    class="rounded-0 mb-4"
                                                    :rules="
                                                        rules.applicantsNumber
                                                    "
                                                    :error="
                                                        getError(
                                                            'applicantsNumber'
                                                        )
                                                    "
                                                    :error-messages="
                                                        getErrorMessages(
                                                            'applicantsNumber'
                                                        )
                                                    "
                                                    @input="
                                                        removeErrorMessage(
                                                            'applicantsNumber'
                                                        )
                                                    "
                                                ></v-select>
                                            </v-col>
                                        </v-row>

                                        <div :key="personalInfoUpdateKey">
                                            <personal-info
                                                v-if="loaded"
                                                :index="index"
                                                :key="index"
                                                :title="
                                                    'Applicant ' +
                                                    intToString(index + 1)
                                                "
                                                :get-error="getError"
                                                :get-error-messages="
                                                    getErrorMessages
                                                "
                                                :remove-error-message="
                                                    removeErrorMessage
                                                "
                                                :value="
                                                    formFields.applicants[index]
                                                "
                                                :logged-in-profile="
                                                    loggedInProfile
                                                "
                                                :form-disabled="formDisabled"
                                                @input="updateApplicant"
                                                v-for="(
                                                    applicantNumber, index
                                                ) in numberOfApplicants"
                                            >
                                            </personal-info>
                                        </div>

                                        <v-row
                                            class="my-0 mx-0 mt-8"
                                            no-gutters
                                        >
                                            <v-col
                                                cols="12"
                                                md="10"
                                                class="text-center"
                                                offset-md="2"
                                            >
                                                <v-row>
                                                    <v-col
                                                        cols="12"
                                                        md="4"
                                                        offset-md="4"
                                                    >
                                                        <v-btn
                                                            color="primary"
                                                            outlined
                                                            class="mr-2 mb-2"
                                                            @click.prevent="
                                                                updateForm
                                                            "
                                                            v-if="
                                                                loggedInProfile &&
                                                                !formDisabled
                                                            "
                                                            block
                                                        >
                                                            Save progress
                                                        </v-btn>
                                                    </v-col>
                                                    <v-col cols="12" md="4">
                                                        <v-btn
                                                            color="primary"
                                                            @click="
                                                                changeStep(2)
                                                            "
                                                            v-if="!formDisabled"
                                                            class="mb-2"
                                                            block
                                                        >
                                                            Continue
                                                        </v-btn>
                                                        <v-btn
                                                            color="primary"
                                                            class="mb-2"
                                                            @click="
                                                                changeStep(2)
                                                            "
                                                            block
                                                            v-else
                                                        >
                                                            Next step
                                                        </v-btn>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                    </v-stepper-content>

                                    <v-stepper-content step="2">
                                        <div :key="employmentUpdateKey">
                                            <employment
                                                v-if="loaded"
                                                :index="index"
                                                :key="index"
                                                :title="
                                                    'Applicant ' +
                                                    intToString(index + 1)
                                                "
                                                :get-error="getError"
                                                :get-error-messages="
                                                    getErrorMessages
                                                "
                                                :remove-error-message="
                                                    removeErrorMessage
                                                "
                                                :value="
                                                    formFields.applicants[index]
                                                "
                                                @input="updateApplicant"
                                                :form-disabled="formDisabled"
                                                :logged-in-profile="
                                                    loggedInProfile
                                                "
                                                v-for="(
                                                    applicantNumber, index
                                                ) in numberOfApplicants"
                                            >
                                            </employment>
                                        </div>

                                        <v-row
                                            class="my-0 mx-0 mt-8"
                                            no-gutters
                                        >
                                            <v-col
                                                cols="12"
                                                md="2"
                                                class="text-center mb-4"
                                            >
                                                <v-btn
                                                    color="secondary"
                                                    @click="changeStep(1)"
                                                    block
                                                >
                                                    Back
                                                </v-btn>
                                            </v-col>
                                            <v-col
                                                cols="12"
                                                md="10"
                                                class="text-center"
                                            >
                                                <v-row>
                                                    <v-col
                                                        cols="12"
                                                        md="4"
                                                        offset-md="4"
                                                    >
                                                        <v-btn
                                                            color="primary"
                                                            outlined
                                                            class="mr-2 mb-2"
                                                            @click.prevent="
                                                                updateForm
                                                            "
                                                            v-if="
                                                                loggedInProfile &&
                                                                !formDisabled
                                                            "
                                                            block
                                                        >
                                                            Save progress
                                                        </v-btn>
                                                    </v-col>
                                                    <v-col cols="12" md="4">
                                                        <v-btn
                                                            color="primary"
                                                            @click="
                                                                changeStep(3)
                                                            "
                                                            v-if="!formDisabled"
                                                            class="mb-2"
                                                            block
                                                        >
                                                            Continue
                                                        </v-btn>
                                                        <v-btn
                                                            color="primary"
                                                            class="mb-2"
                                                            @click="
                                                                changeStep(3)
                                                            "
                                                            block
                                                            v-else
                                                        >
                                                            Next step
                                                        </v-btn>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                    </v-stepper-content>

                                    <v-stepper-content step="3">
                                        <div :key="financeUpdateKey">
                                            <finance
                                                v-if="loaded"
                                                :index="index"
                                                :key="index"
                                                :title="
                                                    'Applicant ' +
                                                    intToString(index + 1)
                                                "
                                                :get-error="getError"
                                                :get-error-messages="
                                                    getErrorMessages
                                                "
                                                :remove-error-message="
                                                    removeErrorMessage
                                                "
                                                :value="
                                                    formFields.applicants[index]
                                                "
                                                :logged-in-profile="
                                                    loggedInProfile
                                                "
                                                :form-disabled="formDisabled"
                                                @input="updateApplicant"
                                                v-for="(
                                                    applicantNumber, index
                                                ) in numberOfApplicants"
                                            >
                                            </finance>
                                        </div>

                                        <v-row
                                            class="my-0 mx-0 mt-8"
                                            no-gutters
                                        >
                                            <v-col
                                                cols="12"
                                                md="2"
                                                class="text-center mb-4"
                                            >
                                                <v-btn
                                                    color="secondary"
                                                    @click="changeStep(2)"
                                                    block
                                                >
                                                    Back
                                                </v-btn>
                                            </v-col>
                                            <v-col
                                                cols="12"
                                                md="10"
                                                class="text-center"
                                            >
                                                <v-row>
                                                    <v-col
                                                        cols="12"
                                                        md="4"
                                                        offset-md="4"
                                                    >
                                                        <v-btn
                                                            color="primary"
                                                            outlined
                                                            class="mr-2 mb-2"
                                                            @click.prevent="
                                                                updateForm
                                                            "
                                                            v-if="
                                                                loggedInProfile &&
                                                                !formDisabled
                                                            "
                                                            block
                                                        >
                                                            Save progress
                                                        </v-btn>
                                                    </v-col>
                                                    <v-col cols="12" md="4">
                                                        <v-btn
                                                            color="primary"
                                                            @click="
                                                                changeStep(4)
                                                            "
                                                            v-if="!formDisabled"
                                                            class="mb-2"
                                                            block
                                                        >
                                                            Continue
                                                        </v-btn>
                                                        <v-btn
                                                            color="primary"
                                                            class="mb-2"
                                                            @click="
                                                                changeStep(4)
                                                            "
                                                            block
                                                            v-else
                                                        >
                                                            Next step
                                                        </v-btn>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                    </v-stepper-content>

                                    <v-stepper-content step="4">
                                        <div :key="livingUpdateKey">
                                            <living
                                                v-if="loaded"
                                                :index="index"
                                                :key="index"
                                                :title="
                                                    'Applicant ' +
                                                    intToString(index + 1)
                                                "
                                                :get-error="getError"
                                                :get-error-messages="
                                                    getErrorMessages
                                                "
                                                :remove-error-message="
                                                    removeErrorMessage
                                                "
                                                :value="
                                                    formFields.applicants[index]
                                                "
                                                :logged-in-profile="
                                                    loggedInProfile
                                                "
                                                :form-disabled="formDisabled"
                                                @input="updateApplicant"
                                                v-for="(
                                                    applicantNumber, index
                                                ) in numberOfApplicants"
                                            >
                                            </living>
                                        </div>

                                        <v-row
                                            class="my-0 mx-0 mt-8"
                                            no-gutters
                                        >
                                            <v-col
                                                cols="12"
                                                md="2"
                                                class="text-center mb-4"
                                            >
                                                <v-btn
                                                    color="secondary"
                                                    @click="changeStep(3)"
                                                    block
                                                >
                                                    Back
                                                </v-btn>
                                            </v-col>
                                            <v-col
                                                cols="12"
                                                md="10"
                                                class="text-center"
                                            >
                                                <v-row>
                                                    <v-col
                                                        cols="12"
                                                        md="4"
                                                        offset-md="4"
                                                    >
                                                        <v-btn
                                                            color="primary"
                                                            outlined
                                                            class="mr-2 mb-2"
                                                            @click.prevent="
                                                                updateForm
                                                            "
                                                            v-if="
                                                                loggedInProfile &&
                                                                !formDisabled
                                                            "
                                                            block
                                                        >
                                                            Save progress
                                                        </v-btn>
                                                    </v-col>
                                                    <v-col cols="12" md="4">
                                                        <v-btn
                                                            @click="submitForm"
                                                            color="primary"
                                                            v-if="!formDisabled"
                                                            class="mb-2"
                                                            block
                                                        >
                                                            Complete
                                                        </v-btn>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                    </v-stepper-content>
                                </v-stepper-items>
                            </v-stepper>
                        </v-col>
                    </v-row>
                </v-form>
            </v-container>
        </v-container>

        <v-dialog
            v-model="responseDialog.show"
            persistent
            :max-width="responseDialog.maxWidth"
        >
            <v-card>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col
                                sm="12"
                                :md="responseDialog.listingCard.show ? 6 : 12"
                                :lg="responseDialog.listingCard.show ? 7 : 12"
                                :xl="responseDialog.listingCard.show ? 7 : 12"
                            >
                                <div class="my-12 pt-16 text-center">
                                    <div
                                        v-if="responseDialog.icon.show"
                                        class="mx-auto mb-12"
                                    >
                                        <v-icon
                                            :size="responseDialog.icon.size"
                                        >
                                            {{ responseDialog.icon.icon }}
                                        </v-icon>
                                    </div>

                                    <div
                                        class="mx-auto mb-6"
                                        v-if="responseDialog.header.show"
                                    >
                                        <h1 v-if="responseDialog.header.text">
                                            {{ responseDialog.header.text }}
                                        </h1>
                                    </div>

                                    <div
                                        class="mx-auto mb-6"
                                        v-if="responseDialog.body.show"
                                        v-html="responseDialog.body.text"
                                    ></div>

                                    <div class="mx-auto">
                                        <v-btn
                                            :color="
                                                responseDialog.dashboardButton
                                                    .color
                                            "
                                            :href="
                                                responseDialog.dashboardButton
                                                    .url
                                            "
                                            v-if="
                                                responseDialog.dashboardButton
                                                    .show
                                            "
                                        >
                                            Back to Dashboard
                                        </v-btn>
                                        <v-btn
                                            :color="
                                                responseDialog.closeButton.color
                                            "
                                            @click="closeResponseDialog"
                                            v-if="
                                                responseDialog.closeButton.show
                                            "
                                        >
                                            Close
                                        </v-btn>
                                    </div>
                                </div>
                            </v-col>

                            <v-col
                                sm="12"
                                md="6"
                                lg="5"
                                xl="5"
                                v-if="responseDialog.listingCard.show"
                                style="display: none"
                            >
                                <listing-card
                                    v-if="listing"
                                    :show-link-to-listing="true"
                                    :link-to-listing="listingUrl"
                                    :listing="listing"
                                ></listing-card>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog
            v-model="choosePreviousApplicationForm"
            persistent
            :max-width="600"
        >
            <v-card>
                <v-card-text>
                    <v-row class="pt-8">
                        <v-col sm="12" md="12" class="text-center">
                            <v-alert text color="primary">
                                <div>
                                    We found previously submitted application
                                    forms.
                                </div>

                                <v-divider
                                    class="my-4 primary"
                                    style="opacity: 0.22"
                                ></v-divider>

                                <v-row align="center" no-gutters>
                                    <div class="mb-4">
                                        Would you like to fill out this new form
                                        with the previously provided
                                        information?
                                    </div>
                                    <v-spacer></v-spacer>
                                    <v-col class="shrink">
                                        <v-btn
                                            @click="
                                                choosePreviousApplicationForm = false
                                            "
                                            color="primary"
                                            outlined
                                            class="mr-4"
                                            >No</v-btn
                                        >
                                        <v-btn
                                            @click="prefillForm()"
                                            color="primary"
                                            >Yes</v-btn
                                        >
                                    </v-col>
                                </v-row>
                            </v-alert>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import {
    defineComponent,
    ref,
    onMounted,
    computed,
    watch,
    nextTick,
} from "@vue/composition-api";
import {
    has,
    intersection,
    merge,
    find,
    forEach,
    isNil,
    includes,
    isNumber,
    findIndex,
} from "lodash";
import ListingService from "../services/ListingService";
import PropertyService from "../services/PropertyService";
import ListingCard from "./ListingCard.vue";
import PersonalInfo from "./partials/application-form/PersonalInfo.vue";
import Employment from "./partials/application-form/Employment.vue";
import Finance from "./partials/application-form/Finance.vue";
import Living from "./partials/application-form/Living.vue";
import Equality from "./partials/application-form/Equality.vue";
import ProfileService from "../services/ProfileService";

export default defineComponent({
    name: "ApplicationForm",
    components: {
        ListingCard,
        PersonalInfo,
        Employment,
        Finance,
        Living,
        Equality,
    },
    props: {
        rootUrl: {
            type: String,
            required: true,
        },
        listingSlug: {
            type: String,
        },
        propertyId: {
            type: Number,
        },
        housingProviderName: {
            type: String,
        },
        assessmentId: {
            type: Number,
        },
        settings: {
            type: Object,
        },
    },
    setup(props, context) {
        const loading = ref(false);
        const loaded = ref(false);
        const form = ref(null);
        const formValid = ref(false);
        const listing = ref(null);
        const step = ref(1);
        const property = ref({});
        const checkEligibility = ref(null);
        const properties = ref([]);
        const formDisabled = ref(false);
        const formFields = ref({
            applicantsNumber: 1,
            applicants: [{}],
        });
        const draftApplications = ref([]);
        const personalInfoUpdateKey = ref(0);
        const employmentUpdateKey = ref(0);
        const financeUpdateKey = ref(0);
        const livingUpdateKey = ref(0);
        const equalityUpdateKey = ref(0);
        const existingAssessmentId = ref(null);
        const choosePreviousApplicationForm = ref(false);
        const previouslySubmittedForms = ref([]);

        const numberOfApplicants = computed(() => {
            return parseInt(formFields.value.applicantsNumber);
        });

        const applicantsChoices = ref([
            { text: "One", value: 1 },
            { text: "Two", value: 2 },
            { text: "Three", value: 3 },
        ]);

        const showDatePicker = ref(false);
        const picker = ref(null);
        const menu = ref(null);
        const formResponse = ref({});

        const rules = ref({
            applicantsNumber: [
                (v) => !!v || "Number of Applicants is required",
            ],
        });

        const validationErrors = ref([]);

        const loginDialog = ref(false);

        const responseDialog = ref({
            maxWidth: "540px",
            show: false,
            icon: {
                show: true,
                size: 112,
                icon: "mdi-text-box-check-outline",
            },
            header: {
                show: true,
                text: "Your application has been submitted",
            },
            body: {
                show: true,
                text: "<p>Please check your email for more information</p>",
            },
            listingCard: {
                show: true,
            },
            searchButton: {
                show: false,
                color: "primary",
            },
            dashboardButton: {
                show: false,
                color: "primary",
            },
            closeButton: {
                show: true,
                color: "primary",
            },
        });

        const defaultSettings = ref({
            title: {
                show: true,
                text: "Apply",
                classes: "",
                style: "",
            },
            intro: {
                show: true,
                classes: "",
                style: "",
                textHtml:
                    "<p>Applying for this property means the information you provide will be passed to the housing provider, so that they can contact you by email or telephone about your application.</p>",
            },
            listingCard: {
                show: false,
            },
            submitFailureFallbackMessage: {
                show: false,
                message:
                    "Sorry your form submission failed. Please reach out to the provided email address for assistance",
            },
            events: {
                redirectIfNotLoggedIn: "/login",
                redirectIfApplicationFormNotFound: "/404",
            },
        });

        const displayFullResponse = ref(true);
        const loggedInProfile = ref(null);
        const loggedIn = ref(false);

        const listingImage = computed(() => {
            if (listing.value.galleryImages) {
                return find(listing.value.galleryImages, function (o) {
                    return o.main === true;
                });
            }
            return false;
        });

        const listingUrl = computed(() => {
            let listingSlug = listing.value.slug;
            if (has(listing.value, "widgetSiteSettings.customSlug")) {
                if (listing.value.widgetSiteSettings.customSlug) {
                    listingSlug = listing.value.widgetSiteSettings.customSlug;
                }
            }
            if (listingSlug) {
                return props.rootUrl + "/listing/" + listingSlug;
            }
            return "";
        });

        const tabErrors = computed(() => {
            let errors = [];
            forEach(fieldsInTabs.value, function (val, ind) {
                errors[ind] = false;
            });

            forEach(validationErrors.value, function (value, index) {
                const splitted = index.split(".");
                if (splitted[2]) {
                    const fieldName = splitted[2];
                    forEach(fieldsInTabs.value, function (val, ind) {
                        if (includes(val, fieldName)) {
                            errors[ind] = true;
                        }
                    });
                }
            });
            return errors;
        });

        const normalizedOptions = computed(() => {
            return merge(defaultSettings.value, props.settings);
        });

        const currencyFormatter = new Intl.NumberFormat("gb-GB", {
            style: "currency",
            currency: "GBP",
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        });

        const fieldsInTabs = ref({
            1: [
                "email",
                "title",
                "firstName",
                "middleNames",
                "lastName",
                "previousSurname",
                "maritalStatus",
                "gender",
                "MODWorker",
                "relationshipToPrimary",
                "phone",
                "homePhone",
                "workPhone",
                "mobilePhone",
                "dateOfBirth",
                "nationalInsuranceNumber",
                "livingCircumstance",
                "homeAddressLine1",
                "homeAddressLine2",
                "homeTown",
                "homeCounty",
                "homePostcode",
                "homeMoveInDate",
                "previousAddresses",
            ],
            2: [
                "workingCircumstance",
                "occupation",
                "employmentStartDate",
                "employerName",
                "workPostcode",
                "workAddressLine1",
                "workAddressLine2",
                "workTown",
                "workCounty",
                "workLocalAuthorityId",
                "employersContactNumber",
                "employersContactEmail",
            ],
            3: [
                "annualSalary",
                "annualBonuses",
                "monthlyOtherIncome",
                "monthlyTaxCredits",
                "monthlyDisabilityAllowance",
                "monthlyMaintenance",
                "monetaryGift",
                "deposit",
                "savings",
                "monthlyRent",
                "creditCardBalance",
                "hasLoans",
                "loanBalance",
                "loanPurpose",
                "loanEndDate",
                "monthlyCreditCardAndLoanPayments",
                "failedLoanOrCreditAgreement",
                "declaredBankrupt",
                "enteredIVA",
            ],
            4: [
                "councilWaitingListReferenceNumber",
                "ownPets",
                //'ownsProperty', 'homeOwnershipStatus', 'currentHomeBeds', 'laRegistered',
                //'homeBuyRegistered', 'helpToBuyRegistered', 'ownPets', 'dependants'
            ],
            5: [
                //'nationality', 'ethnicity', 'religion', 'sexuality',
                //'relatedToHAWorker', 'relationshipToHAWorker', 'anyoneInHouseholdDisabled', 'registeredDisabled',
                //'wheelchairUser', 'accessibilityNeeds'
            ],
        });

        const fieldLabels = ref({
            MODWorker: "Are you current or ex-serving MoD personnel?",
            phone: "Phone number",
            homePhone: "Home phone number",
            workPhone: "Work phone number",
            mobilePhone: "Mobile phone number",
            livingCircumstance: "Current accommodation",
            homeAddressLine1: "Current address - House name or number",
            homeAddressLine2: "Current address - Street address",
            homePostcode: "Current address - Postcode",
            homeMoveInDate: "Current address - Move in date",
            workingCircumstance: "Current employment status",
            workAddressLine1: "Work building name or number",
            workAddressLine2: "Work street address",
            workLocalAuthorityId: "Work local authority",
            employersContactNumber: "Employer's contact number",
            employersContactEmail: "Employer's contact email",
            deposit: "Expected deposit amount",
            savings: "Total savings amount",
            monthlyCreditCardAndLoanPayments:
                "Monthly credit card & loan payments",
            failedLoanOrCreditAgreement:
                "Have you ever failed to keep up on a loan or any form of credit agreement?",
            declaredBankrupt:
                "Have you ever been declared bankrupt or han an unsatisfied CCJ within the last 6 years?",
            enteredIVA:
                "Are you entered into an IVA? (Individual Voluntary Credit Agreement)",
            ownPets: "Do you have any Pets?",
        });

        const previousAddressFields = ref({
            addressLine1: "House name or number",
            addressLine2: "Street address",
            postcode: "Postcode",
            moveInDate: "Move in date",
        });

        watch(showDatePicker, (currentValue) => {
            currentValue &&
                setTimeout(() => (picker.value.activePicker = "YEAR"));
        });

        onMounted(() => {
            init();
        });

        function init() {
            loaded.value = false;
            ProfileService.getProfile()
                .then((response) => {
                    loggedIn.value = true;
                    loggedInProfile.value = response;

                    if (props.assessmentId) {
                        ProfileService.getApplicationForm(props.assessmentId)
                            .then((assessment) => {
                                formFields.value.applicants =
                                    assessment.data.applicants;
                                if (assessment.data.status == "submitted") {
                                    formDisabled.value = true;
                                }

                                if (assessment.data.applicantsNumber) {
                                    formFields.value.applicantsNumber =
                                        assessment.data.applicantsNumber;
                                } else {
                                    formFields.value.applicantsNumber =
                                        assessment.data.applicants.length;
                                }

                                if (assessment.data.listing) {
                                    listing.value = assessment.data.listing;
                                }

                                if (assessment.data.property) {
                                    property.value = assessment.data.property;
                                }
                                existingAssessmentId.value = assessment.data.id;

                                // Update components.
                                updateComponents();
                            })
                            .catch((error) => {
                                if (has(error, "response.status")) {
                                    if (
                                        has(
                                            normalizedOptions.value,
                                            "events.redirectIfApplicationFormNotFound"
                                        ) &&
                                        error.response.status == 404
                                    ) {
                                        window.location.href =
                                            normalizedOptions.value.events.redirectIfApplicationFormNotFound;
                                    }
                                }
                                console.error(error);
                            });
                    } else {
                        if (isNumber(props.propertyId)) {
                            fetchProperty(props.listingSlug, props.propertyId);
                        } else {
                            fetchListing(props.listingSlug);
                        }

                        populateFormFromExistingApplicationform();
                    }
                })
                .catch((error) => {
                    console.error(error);
                    loggedIn.value = false;
                    redirectToLogin();
                })
                .then(() => {
                    loaded.value = true;
                });
        }

        function toggleLoading(val) {
            loading.value = val;
        }

        function isFieldInCollection(fieldName, fieldType) {
            return includes(registerInterestFields.value[fieldType], fieldName);
        }

        // User-friendly conversion from int to text string
        function intToString(val) {
            let value = "One";

            switch (val) {
                case 3:
                    value = "Three";
                    break;
                case 2:
                    value = "Two";
                    break;
                default:
                    return value;
            }

            return value;
        }

        /**************************
         * DATA SETTERS & GETTERS
         *************************/

        function fetchProperty(listingSlug, propertyId) {
            loading.value = true;
            PropertyService.getRegisterInterestFieldsWithPropertyDetails(
                listingSlug,
                propertyId
            )
                .then(function (response) {
                    if (response.data.registerInterestFields) {
                        checkEligibility.value =
                            intersection(
                                response.data.registerInterestFields
                                    .eligibilityFields,
                                ["annualHouseholdIncome", "deposit"]
                            ).length > 0;
                    }
                    if (response.data.listing) {
                        listing.value = response.data.listing;
                    }
                    if (response.data.property) {
                        property.value = response.data.property;
                    }
                    if (response.data.properties) {
                        properties.value = response.data.properties;
                    }
                })
                .catch(function (error) {
                    console.error(error);
                })
                .then(function () {
                    loading.value = false;
                });
        }

        function fetchListing(listingSlug) {
            loading.value = true;
            ListingService.getListingFullDetailsBySlug(listingSlug)
                .then(function (response) {
                    if (response.data.registerInterestFields) {
                        checkEligibility.value =
                            intersection(
                                response.data.registerInterestFields
                                    .eligibilityFields,
                                ["annualHouseholdIncome", "deposit"]
                            ).length > 0;
                    }
                    if (response.data.listing) {
                        listing.value = response.data.listing;
                    }
                    if (response.data.property) {
                        property.value = response.data.property;
                    }
                    if (response.data.properties) {
                        properties.value = response.data.properties;
                    }
                })
                .catch(function (error) {
                    console.log(error);
                })
                .then(function () {
                    loading.value = false;
                });
        }

        function buildPayload() {
            // Adding the listing id to the payload, and reduce the applicants array to the corresponding value.
            let payload = {
                listingId: listing.value.id,
                applicants: [],
            };

            let applicantsNumber = numberOfApplicants.value;

            for (let i = 1; i <= applicantsNumber; i++) {
                let objectKey = i - 1;
                payload.applicants.push(formFields.value.applicants[objectKey]);
            }

            if (loggedInProfile.value && existingAssessmentId.value) {
                payload.assessmentId = existingAssessmentId.value;
            }

            // console.log(payload);

            return payload;
        }

        function submitForm() {
            let payload = buildPayload();

            // console.log(payload);
            ProfileService.submitApplicationForm(payload)
                .then(function (response) {
                    handleSuccess("complete");
                })
                .catch(function (error) {
                    console.error(error);
                    handleErrors(error);
                })
                .then(() => {});
        }

        function updateApplicant(index, applicant) {
            form.value.resetValidation();
            if (!formFields.value.applicants[index]) {
                formFields.value.applicants[index] = applicant;
            }

            let existingFields = formFields.value.applicants[index];
            let incomingFields = applicant;

            formFields.value.applicants[index] = {};
            formFields.value.applicants[index] = {
                ...existingFields,
                ...incomingFields,
            };
        }

        function saveDobField(date) {
            menu.value.save(date);
        }

        function updateForm() {
            loading.value = true;
            let payload = buildPayload();
            let existingAssessment = null;
            if (existingAssessmentId.value) {
                existingAssessment = parseInt(existingAssessmentId.value);
            }
            ProfileService.saveApplicationForm(payload, existingAssessment)
                .then(function (response) {
                    if (response.data.id) {
                        formFields.value.assessmentId = response.data.id;
                        existingAssessmentId.value = response.data.id;
                        handleSuccess("save");
                    }
                })
                .catch(function (error) {
                    handleErrors(error);
                })
                .then(() => {
                    loading.value = false;
                });
        }

        function populateFormFromExistingApplicationform() {
            loading.value = true;
            ProfileService.getApplicationForms()
                .then(function (response) {
                    if (has(response, "data.data")) {
                        previouslySubmittedForms.value =
                            response.data.data.filter(
                                (obj) => obj.status === "submitted"
                            );
                        if (previouslySubmittedForms.value.length > 0) {
                            choosePreviousApplicationForm.value = true;
                        }
                    }
                })
                .catch(function (error) {
                    console.error(error);
                })
                .then(() => {
                    loading.value = false;
                });
        }

        /**************************
         * DIALOGS
         *************************/

        function openLoginDialog() {
            loginDialog.value = true;
        }

        function closeLoginDialog() {
            loginDialog.value = false;
        }

        function handleLoginDialogEmit(val) {
            loginDialog.value = val;
        }

        function closeResponseDialog() {
            responseDialog.value.show = false;
        }

        /**************************
         * VALIDATION and Error handling
         *************************/

        function validateForm() {
            let valid = form.value.validate();
            if (valid) {
                submitForm();
            } else {
                nextTick(() => {
                    const target = document.querySelector(
                        ".v-messages.error--text:first-of-type"
                    );
                    scrollToElement(target, 300, 72);
                });
            }
        }

        function getError(fieldName) {
            return has(validationErrors.value, fieldName);
        }

        function getErrorMessages(fieldName) {
            if (getError(fieldName)) {
                return validationErrors.value[fieldName];
            }
            return [];
        }

        function removeErrorMessage(fieldName) {
            if (getError(fieldName)) {
                delete validationErrors.value[fieldName];
            }
        }

        function snakeToSentence(value) {
            const result = value.replace(/([A-Z])/g, " $1");
            return result[0].toUpperCase() + result.substring(1).toLowerCase();
        }

        function getValidationErrorMessageBody(errors) {
            if (Object.keys(errors).length < 1) {
                return "<p>Validation error(s) occurred.</p>";
            }
            let messages = [];
            messages[1] = [];
            messages[2] = [];
            messages[3] = [];
            Object.keys(errors).forEach((key) => {
                const split = key.split(".");
                const applicant = parseInt(split[1]) + 1;
                const field = split[2];
                if (
                    field === "previousAddresses" &&
                    previousAddressFields.value[split[4]] !== undefined
                ) {
                    messages[applicant].push(
                        "Previous address " +
                            (parseInt(split[3]) + 1) +
                            " - " +
                            previousAddressFields.value[split[4]]
                    );
                } else if (field === "previousAddresses") {
                    messages[applicant].push(
                        "Previous address " +
                            (parseInt(split[3]) + 1) +
                            " - " +
                            messages[applicant].push(snakeToSentence(split[4]))
                    );
                } else if (fieldLabels.value[field] !== undefined) {
                    messages[applicant].push(fieldLabels.value[field]);
                } else {
                    messages[applicant].push(snakeToSentence(field));
                }
            });
            let body = `<p>The following field${
                Object.keys(errors).length > 1 ? "s have" : " has"
            } validation errors.</p>`;
            messages.forEach((applicantErrors, applicantNumber) => {
                if (applicantErrors.length > 0) {
                    body += `<p>Applicant ${applicantNumber}:</p><ul>`;
                    applicantErrors.forEach((error) => {
                        body += `<li>${error}</li>`;
                    });
                    body += "</ul>";
                }
            });
            return body;
        }

        function handleErrors(errors) {
            let bodyShow = true;
            let bodyText = "<p>An error occurred</p>";
            if (
                normalizedOptions.value.submitFailureFallbackMessage.show ===
                true
            ) {
                bodyText +=
                    normalizedOptions.value.submitFailureFallbackMessage
                        .message;
            }
            let headerError = "Server error";
            if (errors.response.status) {
                if (
                    errors.response.status == 422 &&
                    errors.response.data.errors
                ) {
                    validationErrors.value = errors.response.data.errors;
                    window.scrollTo(0, 0);
                    headerError = "Validation error";
                    if (errors.response.data.errors.length !== 1) {
                        headerError += "s";
                    }
                    bodyShow = true;
                    bodyText = getValidationErrorMessageBody(
                        validationErrors.value
                    );
                } else {
                    if (errors.response.data.message) {
                        bodyShow = true;
                        bodyText =
                            "<p>" + errors.response.data.message + "</p>";
                        if (
                            normalizedOptions.value.submitFailureFallbackMessage
                                .show === true
                        ) {
                            bodyText +=
                                normalizedOptions.value
                                    .submitFailureFallbackMessage.message;
                        }
                    }
                }
                const firstTabError = findIndex(tabErrors.value, function (o) {
                    return o;
                });
                if (firstTabError > 0) {
                    changeStep(firstTabError);
                }
                responseDialog.value = {
                    maxWidth: "540px",
                    show: true,
                    icon: {
                        show: true,
                        size: 112,
                        icon: "mdi-alert-circle",
                    },
                    header: {
                        show: true,
                        text: headerError,
                    },
                    body: {
                        show: bodyShow,
                        text: bodyText,
                    },
                    listingCard: {
                        show: false,
                    },
                    dashboardButton: {
                        show: false,
                        color: "primary",
                        url: "/dashboard",
                    },
                    searchButton: {
                        show: false,
                        color: "primary",
                    },
                    closeButton: {
                        show: true,
                        color: "primary",
                    },
                };
            }
        }

        function handleSuccess(type) {
            let headerText = "";
            let bodyText = "";
            if (type == "save") {
                headerText = "Your progress has been saved";
                bodyText =
                    "<p>You can complete and submit the form when it is convenient for you.</p>";
            } else if (type == "complete") {
                headerText = "Your application has been submitted";
                bodyText = "";
            }

            let showCloseButton = false;

            if (type == "save" && props.assessmentId > 0) {
                showCloseButton = true;
            }

            responseDialog.value = {
                show: true,
                maxWidth: "540px",
                icon: {
                    show: true,
                    size: 112,
                    icon: "mdi-text-box-check-outline",
                },
                header: {
                    show: true,
                    text: headerText,
                },
                body: {
                    show: true,
                    text: bodyText,
                },
                listingCard: {
                    show: false,
                },
                dashboardButton: {
                    show: true,
                    color: "primary",
                    url: "/dashboard",
                },
                searchButton: {
                    show: false,
                    url: "",
                    color: "primary",
                },
                closeButton: {
                    show: showCloseButton,
                    color: "primary",
                },
            };
        }

        function changeStep(toStepNumber) {
            step.value = toStepNumber;

            const target = document.querySelector(".v-stepper");
            scrollToElement(target, 300, 72);
        }

        function updateComponents(componentKey = null) {
            if (componentKey) {
                componentKey.value = componentKey.value + 1;
            } else {
                personalInfoUpdateKey.value = personalInfoUpdateKey.value + 1;
                employmentUpdateKey.value = employmentUpdateKey.value + 1;
                financeUpdateKey.value = financeUpdateKey.value + 1;
                livingUpdateKey.value = livingUpdateKey.value + 1;
                equalityUpdateKey.value = equalityUpdateKey.value + 1;
            }
        }

        function redirectToLogin() {
            if (has(normalizedOptions.value, "events.redirectIfNotLoggedIn")) {
                window.location.href =
                    normalizedOptions.value.events.redirectIfNotLoggedIn;
            }
        }

        function scrollToElement(
            target,
            duration = 300,
            offset = 0,
            easing = "easeInOutCubic"
        ) {
            if (isNil(target)) {
                return;
            }
            let options = {
                duration: duration,
                offset: offset,
                easing: easing,
            };
            context.root.$vuetify.goTo(target, options);
        }

        function prefillForm() {
            if (previouslySubmittedForms.value.length > 0) {
                formFields.value.applicants =
                    previouslySubmittedForms.value[0].formFields.applicants;
                formFields.value.applicantsNumber =
                    previouslySubmittedForms.value[0].formFields.applicants.length;
                updateComponents();
            }
            choosePreviousApplicationForm.value = false;
        }

        return {
            // Variables
            loading,
            step,
            numberOfApplicants,
            loginDialog,
            formValid,
            form,
            checkEligibility,
            listing,
            property,
            currencyFormatter,
            formFields,
            applicantsChoices,
            showDatePicker,
            picker,
            menu,
            rules,
            validationErrors,
            formResponse,
            listingImage,
            listingUrl,
            loggedIn,
            responseDialog,
            displayFullResponse,
            loggedInProfile,
            fieldsInTabs,
            tabErrors,
            draftApplications,
            personalInfoUpdateKey,
            employmentUpdateKey,
            financeUpdateKey,
            livingUpdateKey,
            equalityUpdateKey,
            normalizedOptions,
            formDisabled,
            loaded,
            choosePreviousApplicationForm,

            // Functions
            toggleLoading,
            saveDobField,
            isFieldInCollection,
            validateForm,
            submitForm,
            updateApplicant,
            getError,
            getErrorMessages,
            removeErrorMessage,
            handleLoginDialogEmit,
            openLoginDialog,
            closeLoginDialog,
            closeResponseDialog,
            intToString,
            updateForm,
            changeStep,
            scrollToElement,
            prefillForm,
        };
    },
});
</script>

<style scoped>
.v-stepper__wrapper {
    overflow: auto !important;
}
</style>
